export default __webpack_public_path__ + "static/media/020-big ben.aa750520.svg";